/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import { Box, Heading, Stack, Text } from '@towersystems/towersystems-design-system';
import { map } from 'lodash';
import page from 'page';

/**
 * Internal dependencies
 */
import CardGrid from 'components/card-grid';
import PlanCard from './plan-card';

/**
 * Style dependencies
 */
import './styles.scss';

const PlansCardGrid = ({ plans, items = [], columns = '3' }) => {
    let gridItems = map(plans, (item) => ({
        key: item.id,
        renderer: PlanCard,
        onClick: ({ id, url }) => page(url || '/dashboard/' + id + '/subscribe'),
        ...item,
    }));

    gridItems = [...gridItems, ...items];

    return <CardGrid className='plans-card-grid' columns={columns} items={gridItems} />;
};

export default PlansCardGrid;
